import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/views/layout/Layout'

Vue.use(Router)

const DEF_USER_PATH = '/user'
const DEF_ADMIN_PATH = DEF_USER_PATH + '/admin'
const DEF_MEMBER_PATH = DEF_USER_PATH + '/member'
const DEF_REGION_PATH = '/region'
const DEF_MERCHANT_PATH = '/merchant'
const DEF_ORDERS_PATH = '/orders'
const DEF_GIFTS_PATH = '/gift'
const DEF_CHART_PATH = '/chart'
const DEF_PAYMENT_PATH = '/payment'
const DEF_STTM_PATH = '/statement'
const DEF_MESSAGE_PATH = '/message'
const DEF_WEB_PATH = '/web'
const DEF_BLOG_PATH = '/blog'
const DEF_SETTING_PATH = '/setting'
const DEF_EVENT_PATH = '/event'
const DEF_BRAND_PATH = '/brand'
const DEF_SOA_PATH = '/soa'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/goog-auth', component: () => import('@/views/login/goog-auth'), hidden: true },
  { path: '/reset-password', component: () => import('@/views/login/reset-password'), hidden: true },
  { path: '/otp', component: () => import('@/views/login/otp'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },

  {
    path: '',
    redirect: 'dashboard',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: 'dashboard', icon: 'dashboard', noCache: true }
      }
    ]
  },

  {
    path: DEF_USER_PATH,
    redirect: DEF_USER_PATH + '/admin/admin_user',
    component: Layout,
    name: 'User',
    meta: { title: 'user', icon: 'baseline-people-24px' },
    children: [
      {
        path: DEF_ADMIN_PATH,
        redirect: DEF_ADMIN_PATH + '/admin_user',
        name: 'Admin',
        component: () => import('@/views/parent/index'),
        meta: { title: 'admin', icon: 'baseline-stars-24px' },
        children: [
          getDefSet(DEF_ADMIN_PATH, 'admin_user', 'baseline-people-24px'),
          getDefSet(DEF_ADMIN_PATH, 'admin_role', 'settings_accessibility')
        ]
      },
      getDefSet(DEF_USER_PATH, 'manager', 'baseline-work-24px'),
      {
        path: DEF_MEMBER_PATH,
        redirect: DEF_MEMBER_PATH + '/funnow',
        name: 'FunNow',
        component: () => import('@/views/parent/index'),
        meta: { title: 'group_member.name', icon: 'baseline-account_circle-24px' },
        children: [
          getDefSet(DEF_MEMBER_PATH, 'funnow', 'baseline-people-24px'),
          getDefSet(DEF_MEMBER_PATH, 'niceday', 'baseline-people-24px'),
          getDefSet(DEF_MEMBER_PATH, 'eatigo', 'baseline-people-24px'),
          getDefSet(DEF_MEMBER_PATH, 'mbrtag', 'baseline-local_offer-24px'),
          getDefSet(DEF_MEMBER_PATH, 'blacklist', 'block-24px'),
          {
            hidden: true,
            path: DEF_MEMBER_PATH + '/funcoin',
            name: 'FunCoin',
            component: () => import('@/views/parent/index'),
            meta: { title: 'funCoin', icon: 'baseline-attach_money-24px' },
            children: [
              {
                path: 'index',
                name: 'FunCoinLog',
                component: () => import('@/views/dashboard/index'),
                meta: { title: 'funCoinLog' }
              },
              {
                path: 'convert',
                name: 'FunCoinConvert',
                component: () => import('@/views/tree/index'),
                meta: { title: 'funCoinConvert' }
              }
            ]
          },
          {
            hidden: true,
            path: 'vip',
            name: 'VIP',
            component: () => import('@/views/tree/index'),
            meta: { title: 'memberVIP', icon: 'diamond' }
          },
          {
            hidden: true,
            path: DEF_MEMBER_PATH + '/point',
            redirect: DEF_MEMBER_PATH + '/point/log',
            name: 'Point',
            component: () => import('@/views/parent/index'),
            meta: { title: 'memberPoint', icon: 'baseline-favorite-24px' },
            children: [
              {
                path: 'log',
                name: 'PointLog',
                component: () => import('@/views/dashboard/index'),
                meta: { title: 'memberPointLog' }
              },
              {
                path: 'setting',
                name: 'PointSetting',
                component: () => import('@/views/tree/index'),
                meta: { title: 'memberPointSetting' }
              },
              {
                path: 'auth',
                name: 'PointAuth',
                component: () => import('@/views/form/index'),
                meta: { title: 'memberPointAuth' }
              },
              {
                path: 'refer',
                name: 'PointRefer',
                component: () => import('@/views/tree/index'),
                meta: { title: 'memberPointRefer' }
              },
              {
                path: 'notice',
                name: 'PointNotice',
                component: () => import('@/views/tree/index'),
                meta: { title: 'memberPointNotice' }
              },
              {
                path: 'txn',
                name: 'PointTxn',
                component: () => import('@/views/tree/index'),
                meta: { title: 'memberPointTxn' }
              },
              {
                path: 'max',
                name: 'PointMax',
                component: () => import('@/views/tree/index'),
                meta: { title: 'memberPointMax' }
              }
            ]
          }
        ]
      }
    ]
  },

  {
    path: DEF_REGION_PATH,
    redirect: DEF_REGION_PATH + '/region',
    component: Layout,
    name: 'RegionBase',
    meta: { title: 'region.name', icon: 'baseline-near_me-24px' },
    children: [
      getDefSet(DEF_REGION_PATH, 'region', 'baseline-place-24px'),
      {
        path: DEF_REGION_PATH + '/category',
        redirect: DEF_REGION_PATH + '/category/category',
        name: 'Category',
        component: () => import('@/views/parent/index'),
        meta: { title: 'category.name', icon: 'baseline-category-24px' },
        children: [
          getDefSet(DEF_REGION_PATH + '/category', 'category', 'baseline-category-24px'),
          getDefSet(DEF_REGION_PATH + '/category', 'filter', 'baseline-filter_list-24px')
        ]
      },
      {
        path: DEF_REGION_PATH + '/tag',
        redirect: DEF_REGION_PATH + '/tag/prodtag',
        name: 'Tag',
        component: () => import('@/views/parent/index'),
        meta: { title: 'tag', icon: 'baseline-local_offer-24px' },
        children: [
          getDefSet(DEF_REGION_PATH + '/tag', 'prodtag', 'baseline-local_offer-24px'),
          getDefSet(DEF_REGION_PATH + '/tag', 'prodtag_group', 'baseline-category-24px'),
          getDefSet(DEF_REGION_PATH + '/tag', 'prodtag_uniqtag', 'rate_review-24px') // ,
          // getDefSet(DEF_REGION_PATH + '/tag', 'prodfilter', 'baseline-filter_list-24px')
        ]
      },
      getDefSet(DEF_REGION_PATH, 'banner', 'baseline-view_carousel-24px'),
      getDefSet(DEF_REGION_PATH, 'eventnews', 'event_white_24dp'),
      getDefSet(DEF_REGION_PATH, 'hotsearch', 'rate_review-24px'),
      getDefSet(DEF_REGION_PATH, 'dlvarea', 'delivery_dining_white_24dp'),
      getDefSet(DEF_REGION_PATH, 'title', 'title_white_24dp')
    ]
  },

  {
    path: DEF_MERCHANT_PATH,
    redirect: DEF_MERCHANT_PATH + '/branch',
    component: Layout,
    name: 'MerchantBase',
    meta: { title: 'merchant.name', icon: 'baseline-work-24px' },
    children: [
      getDefSet(DEF_MERCHANT_PATH, 'merchant', 'baseline-business-24px'),
      {
        path: DEF_MERCHANT_PATH + '/branch',
        redirect: DEF_MERCHANT_PATH + '/branch/list',
        name: 'Branch',
        meta: { title: 'branch.name', icon: 'baseline-store-24px' },
        component: () => import('@/views/parent/index'),
        children: [
          getDefSet(DEF_MERCHANT_PATH, 'branch', 'baseline-store-24px'),
          getDefSet(DEF_MERCHANT_PATH, 'aos_forms', 'baseline-library_books-24px')
        ]
      },
      getDefSet(DEF_MERCHANT_PATH, 'product', 'baseline-shopping_basket-24px'),
      getDefSet(DEF_MERCHANT_PATH, 'upgrade', 'baseline-library_add-24px'),
      {
        path: DEF_MERCHANT_PATH + '/resource',
        redirect: DEF_MERCHANT_PATH + '/resource/resource_group',
        name: 'Resource',
        component: () => import('@/views/parent/index'),
        meta: { title: 'resource.name', icon: 'baseline-local_hotel-24px' },
        children: [
          getDefSet(DEF_MERCHANT_PATH + '/resource', 'resource_group', 'baseline-category-24px'),
          getDefSet(DEF_MERCHANT_PATH + '/resource', 'resource', 'baseline-local_hotel-24px')
        ]
      },
      {
        path: DEF_MERCHANT_PATH + '/remark',
        redirect: DEF_MERCHANT_PATH + '/remark/remark',
        name: 'Remark',
        component: () => import('@/views/parent/index'),
        meta: { title: 'remarks_collapse.name', icon: 'baseline-insert_comment-24px' },
        children: [
          getDefSet(DEF_MERCHANT_PATH + '/remark', 'remark', 'baseline-insert_comment-24px'),
          getDefSet(DEF_MERCHANT_PATH + '/remark', 'remark_group', 'baseline-category-24px')
        ]
      }
    ]
  },

  {
    path: DEF_ORDERS_PATH,
    redirect: DEF_ORDERS_PATH + '/orders',
    component: Layout,
    name: 'OrdersBase',
    meta: { title: 'orders.name', icon: 'baseline-library_books-24px' },
    children: [
      getDefSet(DEF_ORDERS_PATH, 'orders', 'baseline-library_books-24px'),
      getDefSet(DEF_ORDERS_PATH, 'reservation', 'baseline-library_books-24px'),
      getDefSet(DEF_ORDERS_PATH, 'refund', 'baseline-undo-24px'),
      getDefSet(DEF_ORDERS_PATH, 'invoice', 'baseline-receipt-24px'),
      getDefSet(DEF_ORDERS_PATH, 'orders_receipt', 'outline-email-24px')
    ]
  },

  {
    path: DEF_GIFTS_PATH,
    redirect: DEF_GIFTS_PATH + '/giftcard',
    component: Layout,
    name: 'GiftBase',
    meta: { title: 'gift.name', icon: 'baseline-gift-24px' },
    children: [
      getDefSet(DEF_GIFTS_PATH, 'giftcard', 'baseline-giftcard-24px'),
      getDefSet(DEF_GIFTS_PATH, 'gift', 'baseline-gift-24px')
    ]
  },

  {
    path: DEF_CHART_PATH,
    redirect: DEF_CHART_PATH + '/payment',
    component: Layout,
    name: 'ChartBase',
    meta: { title: 'chart.name', icon: 'baseline-show_chart-24px' },
    children: [
      {
        path: DEF_CHART_PATH + DEF_PAYMENT_PATH,
        redirect: DEF_CHART_PATH + DEF_PAYMENT_PATH + '/payment_set',
        name: 'Payment',
        component: () => import('@/views/parent/index'),
        meta: { title: 'payment.name', icon: 'baseline-attach_money-24px' },
        children: [
          getDefSet(DEF_CHART_PATH, 'payment_set', 'baseline-attach_money-24px'),
          getDefSet(DEF_CHART_PATH, 'payment', 'baseline-attach_money-24px'),
          getDefSet(DEF_CHART_PATH, 'payment_brand', 'paid_white_24dp')
        ]
      },
      getDefSet(DEF_CHART_PATH, 'contract', 'contract'),
      getDefSet(DEF_CHART_PATH, 'channel', 'channel'),
      {
        path: DEF_CHART_PATH + DEF_SOA_PATH,
        redirect: DEF_CHART_PATH + DEF_SOA_PATH + '/invoice',
        name: 'SOA',
        component: () => import('@/views/parent/index'),
        meta: { title: 'soa.name', icon: 'baseline-receipt-24px' },
        children: [
          getDefSet(DEF_CHART_PATH + DEF_SOA_PATH, 'soa.invoice', 'order-play', 'invoice'),
          getDefSet(DEF_CHART_PATH + DEF_SOA_PATH, 'soa.note', 'baseline-receipt-24px', 'note'),
          getDefSet(DEF_CHART_PATH + DEF_SOA_PATH, 'soa.receipt', 'receipt-long', 'receipt'),
          getDefSet(DEF_CHART_PATH + DEF_SOA_PATH, 'soa.email', 'outline-email-24px', 'email')
        ]
      },
      {
        path: DEF_CHART_PATH + DEF_STTM_PATH,
        redirect: DEF_CHART_PATH + DEF_STTM_PATH + '/statement',
        name: 'Statement',
        component: () => import('@/views/parent/index'),
        meta: { title: 'statement.name', icon: 'baseline-mail-24px' },
        children: [
          getDefSet(DEF_CHART_PATH + DEF_STTM_PATH, 'statement', 'baseline-mail-24px'),
          getDefSet(DEF_CHART_PATH + DEF_STTM_PATH, 'statement_email', 'outline-email-24px'),
          getDefSet(DEF_CHART_PATH + DEF_STTM_PATH, 'statement_orders_set', 'baseline-library_books-24px'),
          getDefSet(DEF_CHART_PATH + DEF_STTM_PATH, 'statement_orders', 'baseline-library_books-24px'),
          getDefSet(DEF_CHART_PATH + DEF_STTM_PATH, 'statement_orders_brand', 'library_books_24px')
        ]
      },
      getDefSet(DEF_CHART_PATH, 'export', 'baseline-cloud_download-24px')
    ]
  },

  {
    path: DEF_MESSAGE_PATH,
    redirect: DEF_MESSAGE_PATH + '/news',
    component: Layout,
    name: 'MessageBase',
    meta: { title: 'message', icon: 'baseline-chat-24px' },
    children: [
      getDefSet(DEF_MESSAGE_PATH, 'news', 'notification')
    ]
  },

  {
    path: DEF_WEB_PATH,
    redirect: DEF_WEB_PATH + '/blog',
    component: Layout,
    name: 'WebBase',
    meta: { title: 'website', icon: 'baseline-home-24px' },
    children: [
      {
        path: DEF_WEB_PATH + DEF_BLOG_PATH,
        redirect: DEF_WEB_PATH + DEF_BLOG_PATH + '/blog_article',
        name: 'Blog',
        component: () => import('@/views/parent/index'),
        meta: { title: 'blog.name', icon: 'menu_book-24px' },
        children: [
          getDefSet(DEF_WEB_PATH + DEF_BLOG_PATH, 'blog_article', 'article-24px'),
          getDefSet(DEF_WEB_PATH + DEF_BLOG_PATH, 'blog_author', 'face-24px'),
          getDefSet(DEF_WEB_PATH + DEF_BLOG_PATH, 'blog_country', 'flag_white_24dp'),
          getDefSet(DEF_WEB_PATH + DEF_BLOG_PATH, 'blog_category', 'baseline-category-24px'),
          getDefSet(DEF_WEB_PATH + DEF_BLOG_PATH, 'blog_tag', 'baseline-local_offer-24px')
        ]
      },
      getDefSet(DEF_WEB_PATH, 'help', 'article-24px')
    ]
  },

  {
    path: DEF_EVENT_PATH,
    redirect: DEF_WEB_PATH + '/promo',
    component: Layout,
    name: 'EventBase',
    meta: { title: 'event', icon: 'baseline-cake-24px' },
    children: [
      getDefSet(DEF_EVENT_PATH, 'promo', 'baseline-local_offer-24px'),
      getDefSet(DEF_EVENT_PATH, 'campaign', 'sell'),
      getDefSet(DEF_EVENT_PATH, 'promo_campaign', 'baseline-local_offer-24px'),
      getDefSet(DEF_EVENT_PATH, 'member_mission', 'trophy'),
      getDefSet(DEF_EVENT_PATH, 'task', 'coin')
    ]
  },

  {
    path: DEF_SETTING_PATH,
    redirect: DEF_SETTING_PATH + '/language',
    component: Layout,
    name: 'SettingBase',
    meta: { title: 'setting.name', icon: 'baseline-settings-20px' },
    children: [
      getDefSet(DEF_SETTING_PATH, 'template', 'content_paste-24px'),
      getDefSet(DEF_SETTING_PATH, 'language', 'baseline-language-24px'),
      getDefSet(DEF_SETTING_PATH, 'currency', 'baseline-attach_money-24px'),
      {
        path: DEF_SETTING_PATH + DEF_BRAND_PATH,
        redirect: DEF_SETTING_PATH + DEF_BRAND_PATH + '/brand',
        name: 'Brand',
        component: () => import('@/views/parent/index'),
        meta: { title: 'brand.name', icon: 'workspace_premium' },
        children: [
          getDefSet(DEF_SETTING_PATH + DEF_BRAND_PATH, 'brand', 'workspace_premium'),
          getDefSet(DEF_SETTING_PATH + DEF_BRAND_PATH, 'brand_field', 'format_list_numbered')
        ]
      },
      getDefSet(DEF_SETTING_PATH, 'industry', 'baseline-business-24px')
    ]
  },

  { path: '*', component: () => import('@/views/404'), hidden: true }
]

function getDefSet (path, name, icon, pathName) {
  var fullPath = path + '/' + (pathName || name)
  return {
    path: fullPath,
    redirect: fullPath + '/list',
    component: () => import('@/views/parent/index'),
    children: [
      {
        path: 'list',
        name: name + '.list',
        component: () => import('@/views' + fullPath + '/list'),
        meta: { title: name + '.list', icon: icon }
      },
      {
        path: 'create',
        name: name + '.create',
        hidden: true,
        component: () => import('@/views' + fullPath + '/create'),
        meta: { title: name + '.create', noCache: true }
      },
      {
        path: 'edit/:id(\\d+)',
        name: name + '.edit',
        hidden: true,
        component: () => import('@/views' + fullPath + '/edit'),
        meta: { title: name + '.edit', noCache: true }
      }
    ]
  }
}

export default new Router({
  mode: 'history',
  base: window.location.pathName,
  scrollBehavior: (to, from) => {
    if (to.hash && to.hash.startsWith('#tabs-')) {
      return {}
    }
    return {
      y: 0
    }
  },
  routes: constantRouterMap
})
